module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_1_after.jpg
// module id = 1157
// module chunks = 0